import React from 'react';
import { Inbox } from 'lucide-react';

interface EmptyStateProps {
  title: string;
  description?: string;
  icon?: React.ReactNode;
  action?: React.ReactNode;
  /**
   * `compact` reduz padding — bom pra tabs/tabelas embutidas.
   * Padrão é `default`, adequado pra tela cheia.
   */
  size?: 'default' | 'compact';
  className?: string;
}

/**
 * Estado vazio padrão. Substitui os `<p className="text-sm text-gray-500
 * text-center py-6">Nenhum X encontrado</p>` espalhados em
 * MovimentacoesTab, ManutencaoTab, HistoricoResponsaveisDrawer, etc.
 *
 * Ícone padrão é uma caixa vazia (`Inbox`); passe um mais específico via
 * prop pra contextualizar (ex.: `<Package/>` para lista de ativos vazia).
 */
export function EmptyState({
  title,
  description,
  icon,
  action,
  size = 'default',
  className = '',
}: EmptyStateProps) {
  const padding = size === 'compact' ? 'py-6' : 'py-12';
  return (
    <div
      className={`flex flex-col items-center justify-center text-center ${padding} ${className}`.trim()}
    >
      <div className="text-gray-400" aria-hidden>
        {icon ?? <Inbox className="h-10 w-10" />}
      </div>
      <p className="mt-3 text-sm font-medium text-gray-900">{title}</p>
      {description && <p className="mt-1 max-w-md text-sm text-gray-500">{description}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
